import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SpinnerOverlay } from "../../../Components/LoadingAnimations/SpinnerOverlay";
import  FormBlock from "../../../Components/Inputs/FormBlock";
import { useAuth } from "../../../Auth/AuthProvider";
import instance from "../../../Interceptor/api_instance";
import StockSearch from "../../../Components/Inputs/StockSearch";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";

export const NewPartModal = ({ report, setData, close }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [location, setLocation] = useState(user.location.id); // Default location input to user's assigned location
  const [responseModal, setResponseModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [notes, setNotes] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (quantity > selectedOption.quantity) {
      window.alert("Quantity cannot be larger than what is in stock.");
      return;
    }
    try {
      const data = {
        report_id: report.id,
        stock_id: selectedOption.value,
        quantity: parseInt(quantity),
        notes: notes,
      };
      const response = await instance.post("safety/add-part-to-report", data);
      if (response.status === 200) {
        setData((prev) => ({
          ...prev,
          used_parts: [...prev.used_parts, response.data],
        }));
        setIsLoading(false);
        close();
      }
    } catch (err) {
      setResponseModal({
        message: err,
        status: "Error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-mask page-mask-animation">
      {isLoading && <SpinnerOverlay />}
      {responseModal && (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={() => {
            if (responseModal.status === t("forms.type.success")) {
              setResponseModal(null);
              close();
            } else {
              setResponseModal(null);
            }
          }}
        />
      )}
      <div className="new-modal">
        <h3 className="global-h3">
          {t("forms.type.maintenance-report.new-part")}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-block">
            <label className="input-label">{t("forms.type.maintenance-report.part.select-inventory")}</label>
            <div className="input-cont">
              <select
                className="text-input with-border"
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                  setSelectedOption(null);
                }}
              >
                <option value={1}>San Diego</option>
                <option value={22}>Mexicali</option>
                <option value={2}>Tijuana</option>
                <option value={20}>Toyota</option>
                <option value={23}>Velocity</option>
              </select>
            </div>
          </div>
          <div className="form-block">
            <label className="input-label">{t("forms.type.maintenance-report.part.search-part")}</label>
            <div className="input-cont">
              <StockSearch
                onSelect={(option) => setSelectedOption(option)}
                selectedOption={selectedOption}
                location={location}
                key={location}
              />
            </div>
          </div>
          <FormBlock
            update={(e) => setQuantity(e.target.value)}
            value={quantity}
            type={"number"}
            min={0}
            label={t("forms.type.maintenance-report.labels.quantity")}
          />
          <FormBlock
            update={(e) => setNotes(e.target.value)}
            value={notes}
            label={t("forms.type.vehicle.labels.notes")}
          />
          <div className="full-cont">
            <button type="submit" className="change-pwd-btn">
              {t("buttons.submit")}
            </button>
            <button type="button" onClick={close} className="cancel-btn">
              {t("buttons.cancel")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const EditPartModal = ({ report, part, setData, close }) => {
  const [isLoading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const { t } = useTranslation();

  return (
    <div className="page-mask page-mask-animation">
      {isLoading && <SpinnerOverlay />}
      {responseModal && (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={() => {
            if (responseModal.status === t("forms.type.success")) {
              setResponseModal(null);
              close();
            } else {
              setResponseModal(null);
            }
          }}
        />
      )}
      <div className="new-modal">
        <h3 className="global-h3">
          {t("forms.type.maintenance-report.delete-part")}
        </h3>
        <form>
          <div className="form-block">
            <label className="input-label"></label>
          </div>
        </form>
      </div>
    </div>
  );
};
